// 📂 src/backend/firebase/schema/finance/balance-schema.ts

import z from 'zod';

export const BalanceSchema = z.object({
  employeeId: z.string().nullable(), // Null for the "main" business balance

  // Saldo contable: (+) Dinero disponible, (-) Deuda acumulada
  balance_accounting: z.number().default(0),

  // Mapa Real: { "metodo_id": monto_en_moneda_nativa }
  method_balances: z.record(z.string(), z.number()).default({}),

  // --- ACUMULADORES NOMINALES ---
  period_payroll_accounting: z.number().default(0),    // Total pagado en nómina (Neto)
  period_bonuses_accounting: z.number().default(0),    // Total en bonos extras
  period_deductions_accounting: z.number().default(0), // Total retenido (IVSS, etc.)
  period_expenses_accounting: z.number().default(0),   // Otros gastos
  
  lifetime_payroll_accounting: z.number().default(0),
  
  // Pasivos Laborales (Prestaciones Acumuladas)
  accrued_benefits_accounting: z.number().default(0),

  // Contribuciones Especiales Pendientes (Venezuela 2024-2026)
  pending_pension_contributions: z.number().default(0), // Ley de Pensiones 9%
  pending_inces_accrual: z.number().default(0),         // INCES 2%

  last_updated: z.any(),
  last_settlement_at: z.any(),
});

export type Balance = z.infer<typeof BalanceSchema>;
export type BalanceWithId = Balance & { id: string };
